<template>
  <v-layout align-start row wrap>
    <v-flex xs12 sm12 pb-0 pt-0>
      <v-data-table :headers="headers" :items="ListadoUsuarios" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Actualizar Correo y liberar Id de dispositivo</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <!-- ********** -->
            <v-dialog
              id="dialogVacacion"
              v-model="openModalCorreo"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar dark color="red">
                  <v-btn icon dark @click="openModalCorreo = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>
                    <span class="headline">Actualizar correo electrónico</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="updateEmail" dark text>Aceptar</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-col cols="6" sm="12" md="6">
                        <v-text-field
                          label="Correo electrónico"
                          v-model="Usuario.correo"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <v-dialog
              id="dialogVacacion"
              v-model="openModalIMEI"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar dark color="red">
                  <v-btn icon dark @click="openModalIMEI = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>
                    <span class="headline">Liberar Id de Dispositivo</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="updateIMEI" dark text>Aceptar</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-col cols="6" sm="12" md="6">
                        <v-text-field
                          label="Motivo de liberación"
                          v-model="BitacoraLiberacionUsuario.motivoLiberacion"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <!-- ********** -->
          </v-toolbar>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.idUsuario">
              <td>{{ item.nombre }}</td>
              <td>{{ item.noEmpleado }}</td>
              <td>{{ item.correo }}</td>
              <td>{{ item.fechaRegistro }}</td>
              <td>{{ item.imei }}</td>
              <td>
                <div>
                  <v-icon small class="mr-2" @click="pUpdateEmail(item)">edit</v-icon>  
                  <v-icon small @click="pUpdateIMEI(item)">check</v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Resetear</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: "DatoUsuario",
    components: {},
    data() {
        return {
            search: '',
            ListadoUsuarios: [],
            Usuario: {},
            UpdateIMEI: false,
            openModalCorreo: false,
            openModalIMEI: false,
            BitacoraLiberacionUsuario: { IdUsuario: 0, motivoLiberacion: '', FechaLiberacion: '' },
            headers: [
                { text: "Nombre", value: "nombre" },
                { text: "No. de Empleado", value: "noEmpleado" },
                { text: "Correo", value: "correo" },
                { text: "Fecha de Registro", value: "fechaRegistro" },
                { text: "Id de Dispositivo", value: "iMEI" },
                { text: "Acción", value: "" }
            ],
        }
    },
    created() {
        this.default();
    },
    mounted(){

    },
    filter:{

    },
    methods: {
        saludo(){
            alert('hola mundo');
        },
        default() {
            let me = this;
            me.$store.dispatch("setIsBusy", true);
            me.getUserData();
        },
        getUserData() {
            let me = this;
            me.$axios.get("api/Usuario/GetCompleteUsers")
                .then(r => {
                    if (r) {
                        me.ListadoUsuarios = r.data.datos;
                        me.$store.dispatch("setIsBusy", false);
                    }
                }).catch(err => console.err(err));
        },
        pUpdateEmail(item) {
            let me = this;
            me.openModalCorreo = true;
            me.Usuario = item;
        },
        updateEmail() {
            debugger;
            let me = this;
            me.$store.dispatch("setIsBusy", true);
            me.$axios
                .get(`api/Usuario/UpdateUserData?noEmpleado=${me.Usuario.noEmpleado}&email=${me.Usuario.correo}&userIMEI=false&motivo=`)
                .then((r) => {
                    if (r.data.exito) {
                        me.Usuario = {};
                        this.$root.Mensaje("El correo ha sido actualizado.");
                        me.$store.dispatch("setIsBusy", false);
                        me.openModalCorreo = false;
                    }
                })
                .catch((err) => console.log(err));
        },
        pUpdateIMEI(item) {
            let me = this;
            me.openModalIMEI = true;
            me.Usuario = item;
        },
        updateIMEI() {
            debugger;
            let me = this;
            let url = `api/Usuario/UpdateUserData?noEmpleado=${me.Usuario.noEmpleado}&email=${me.Usuario.correo}&userIMEI=true&motivo=${me.BitacoraLiberacionUsuario.motivoLiberacion}`;

            me.$store.dispatch("setIsBusy", true);
            me.$axios
                .get(url)
                .then((r) => {
                    if (r.data.exito) {
                        me.BitacoraLiberacionUsuario = { IdUsuario: 0, motivoLiberacion: '', FechaLiberacion: '' };
                        this.$root.Mensaje("El IMEI ha sido actualizado.");
                        me.$store.dispatch("setIsBusy", false);
                        me.Usuario.imei = null;
                        me.openModalIMEI = false;
                    }
                })
                .catch((err) => console.log(err));
        }
    }
}
</script>